import * as Yup from "yup";

const FILE_SIZE = 1073741824;
const SUPPORTED_FORMATS = ["text/csv"];

export const validationSchema = Yup.object().shape({
    csvData: Yup.mixed()
        .required("Required")
        .test("fileSize", "File Size is too large", value => value === null || (value && value.blobFile?.size <= FILE_SIZE))
        .test("fileType", "Unsupported File Format", value => value === null || (value && SUPPORTED_FORMATS.includes(value.blobFile?.type))),
});